import TagManager from 'react-gtm-module';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

export interface TrackReccoCtaClickProps extends DeferredNavigationProps {
  data: {
    interactionLocation: string;
    linkUrl: string;
    linkText: string;
  };
}

export const trackReccoCtaClick = ({
  data,
  ...deferral
}: TrackReccoCtaClickProps) => {
  const { interactionLocation, linkUrl, linkText } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_recco_cta',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
